import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '@betgames/bg-state-manager';
import { uaParser } from '@betgames/bg-tools';
import { LogoutIcon } from 'twain-sport-fe-mono';
import { app, appSelectors } from 'store/App';
import { auth, authSelectors } from 'store/Auth';
import { balance, balanceSelectors } from 'store/Balance';
import { IconButton } from 'components/IconButton';
import { Balance } from 'components/Balance';
import { routes } from 'utils/routes';
import { sessionStore } from 'store/Session';
import classes from './Header.scss';

export const Header: React.FC = () => {
    const authenticated = useStore(auth.store, authSelectors.isAuthenticated);
    const partnerLogo = useStore(app.store, appSelectors.getLogo);
    const isLogoEnabled = useStore(app.store, appSelectors.getShowLogo);
    const isBalanceEnabled = useStore(app.store, appSelectors.getShowBalance);
    const balanceUnavailable = useStore(balance.store, balanceSelectors.getIsUnavailable);

    const showBalance = isBalanceEnabled ? sessionStore.showBalance : isBalanceEnabled;

    const showLogo = isLogoEnabled ? sessionStore.showLogo : isLogoEnabled;

    const showLogout = !!window.opener || (uaParser.isMobile && !!sessionStore.homeUrl);

    const onClickLogout = () => {
        if (sessionStore.homeUrl) {
            window.location.href = sessionStore.homeUrl;

            return;
        }

        window.close();
    };

    if (!showLogout && (!showBalance || balanceUnavailable) && !showLogo) {
        return null;
    }

    return (
        <header className={classes.container}>
            <div className={classes.widthWrapper}>
                <div className={classes.logoContainer}>
                    {!!partnerLogo && showLogo && (
                        <Link to={routes.lobby}>
                            <img src={partnerLogo} alt="logo" className={classes.logo} />
                        </Link>
                    )}
                </div>
                <div className={classes.info}>
                    {authenticated && showBalance && <Balance />}
                    {showLogout && (
                        <IconButton onClick={onClickLogout}>
                            <LogoutIcon className={classes.logout} />
                        </IconButton>
                    )}
                </div>
            </div>
        </header>
    );
};
